module.exports = __webpack_public_path__ + "static/media/floor_wooden_selfSupport.6399d59a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_wooden_selfSupport.png
 ** module id = 958
 ** module chunks = 0
 **/